import { getSettingValueWithoutAssignment } from "@faire/retailer-visitor-shared/settings/__internal__/getSetting";
import { SUPPORTED_COUNTRIES } from "@faire/web-api--source/indigofair/settings/SUPPORTED_COUNTRIES";
var defaultValue = [
    "USA",
    "CAN",
    "GBR"
];
export var getSettingSupportedCountries = function() {
    return getSettingValueWithoutAssignment(SUPPORTED_COUNTRIES, defaultValue);
};
export var isSupportedCountry = function(iso3166Alpha3) {
    return !!iso3166Alpha3 && getSettingSupportedCountries().includes(iso3166Alpha3);
};
